//
import { Record } from 'immutable';

//  export type TransferHistory = RecordOf<TransferHistoryType>;
export const mkTransferHistory = Record({
  id: undefined,
  clientId: undefined,
  createdAt: undefined,
  modifiedAt: undefined,
  petiRequest: undefined,
  transferId: undefined,
  sourceFundingAccountId: undefined,
  destinationFundingAccountId: undefined,
  providerTransferId: undefined,
  amount: undefined,
  status: undefined,
  sourceStatus: undefined,
  destinationStatus: undefined,
  sourceClearingType: undefined,
  destinationClearingType: undefined,
  failureCode: undefined,
  failureDescription: undefined,
  failureExplanation: undefined,
  estimatedClearingBusinessDays: undefined,
  estimatedClearingDate: undefined,
  dwollaCreatedAt: undefined,
  effectiveOriginationDate: undefined,
  isDeleted: undefined,
});
